import type { components } from "@/shared/api";

export type DashboardPeriod = components["schemas"]["DashboardPeriod"];

// Периоды дашборда в днях (последние N дней по UTC, включая сегодня) — как `DashboardPeriod`
// бэкенда. По умолчанию — 30.
export const DASHBOARD_PERIODS = [7, 30, 90] as const satisfies readonly DashboardPeriod[];
export const DEFAULT_DASHBOARD_PERIOD: DashboardPeriod = 30;
